import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class LocalStorageService {

  constructor() { }
  tokenFromUI:string = "TYASuite!#!TYASuite!TYASuite!#!@";

  getUserDetails() {
    // console.log(this.get('user_data',localStorage.getItem('user_data')));
    return this.get('user_data',localStorage.getItem('user_data'))?this.get('user_data',localStorage.getItem('user_data')):{};
  }

  getUserEmail() {
    return this.getUserDetails().email;
  }
  getUserImage() {
    return this.getUserDetails().image;
  }

  getUserName() {
    if (this.getUserDetails()) {
      return this.getUserDetails().first_name +" "+this.getUserDetails().last_name;
    }
  }

  getUserId() {
    if (this.getUserDetails()) {
      return this.getUserDetails().id;
    }
  }

  getEmpDetails() {
    if (this.get('company_id',localStorage.getItem('company_id')) != 'undefined') {
      return this.get('company_id',localStorage.getItem('company_id'));
    }
  }

  getEmpRoleId() {
    if (localStorage.getItem('emp_role') != 'undefined') {
    //  return JSON.parse(localStorage.getItem('emp_role'));
      return this.get('emp_role',localStorage.getItem('emp_role'));

    }
  }

  getCompanyTitle() {
    if (localStorage.getItem('company_title') != 'undefined') {
      return this.get('company_title',localStorage.getItem('company_title'));
    }
  }

  getCompanyLogo() {
    if (localStorage.getItem('company_logo') != 'undefined') {
      return this.get('company_logo',localStorage.getItem('company_logo'));
    }
  }

  getEmpCompanyId() {
    return this.getEmpDetails();
  }

  getUserRole() {
    return  this.get('emp_role',localStorage.getItem("emp_role"));
  }


  getDashboradAction() {
    if (localStorage.getItem('dashboardAction') != 'undefined') {
      return this.get('dashboardAction',localStorage.getItem('dashboardAction'))
    }
  }
  getDashboradActionType() {
    if (localStorage.getItem('dashboardAction_isTotal') != 'undefined') {
      return this.get('dashboardAction_isTotal',localStorage.getItem('dashboardAction_isTotal'))
    }
  }
  getClentName() {
    if (localStorage.getItem('client_name') != 'undefined') {
      return this.get('client_name',localStorage.getItem('client_name'));
    }
  }
  getClentID() {
    if (localStorage.getItem('client_id') != 'undefined') {
      return this.get('client_id',localStorage.getItem('client_id'));
    }
  }

  getClentType() {
    if (localStorage.getItem('client_type') != 'undefined') {
      return this.get('client_type',localStorage.getItem('client_type'));
    }
  }
  getUserType() {
    if (localStorage.getItem('user_type') != 'undefined') {
      return this.get('user_type',localStorage.getItem('user_type'));
    }
  }
  getMappingMenuID() {
    if (localStorage.getItem('Mapping_Menu_ID') != 'undefined') {
      return localStorage.getItem('Mapping_Menu_ID');
    }
  }

  getMappingEmployeeID() {
    if (localStorage.getItem('Mapping_Employee_ID') != 'undefined') {
      return localStorage.getItem('Mapping_Employee_ID');
    }
  }

  getmenuListbyRoles() {
    return this.get('menus',localStorage.getItem("menus"))
  }

  getMenuIndex() {
    return localStorage.getItem("menuIndex")
  }

  getSelectedMenu() {
    return localStorage.getItem("selectedMenu")
  }

  getPoId() {
    if (localStorage.getItem('po_id') != 'undefined') {
      return this.get('po_id',localStorage.getItem('po_id'));
    }

  }

  getPoUrl() {
    if (localStorage.getItem('po_url') != 'undefined') {
      return this.get('po_url',localStorage.getItem('po_url'));
    }

  }

  getPoScreen() {
    if (localStorage.getItem('po_screen') != 'undefined') {
      return this.get('po_screen',localStorage.getItem('po_screen'));
    }

  }
  getCompanyTheme() {
    if (localStorage.getItem('company_theme') != 'undefined') {
      // return localStorage.getItem('company_theme') == 'null' ? '#035168':localStorage.getItem('company_theme');
       return this.get('company_theme',localStorage.getItem('company_theme')) == 'null' ? '#035168':this.get('company_theme',localStorage.getItem('company_theme'));
    }
  }
  getCompanyThemeColor() {
    if (localStorage.getItem('company_theme_text') != 'undefined') {
      // return localStorage.getItem('company_theme_text') == 'null' ? "#FFFFFF" : localStorage.getItem('company_theme_text');
       return this.get('company_theme_text',localStorage.getItem('company_theme_text')) == 'null' ? "#FFFFFF" : this.get('company_theme_text',localStorage.getItem('company_theme_text'));
    }
  }
  set(value,key?:string)
  {
    // console.log(value);
    // console.log(key);
  // try{
  //   if(localStorage.getItem('is_enc_on')=='MQ=='||key=='is_enc_on'||key=='is_login_psw')
  //   // if(localStorage.getItem('is_enc_on')=='MQ==')
  //   {
  //     return btoa(value);
  //   }
  //   else
  //   {
  //     return value
  //   }
  // }
  // catch(e)
  // {
  // return value
  // }
  let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
  let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
  try{
     if(localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg=='||key=='is_enc_on'||key=='is_login_psw')
     {
      return CryptoJS.AES.encrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString();
     }
    }
     catch(e)
     {
       console.log(e.name);
       console.log(e.message);
  return value
     }

  }
  get(key,value,is_cookie?:string)
  {
  //   try {
  //   if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && localStorage.getItem('is_enc_on')=='MQ==')
  //   {
  //     // console.log('hey3');

  //     return (atob(value)!=''&&atob(value)!=undefined&&atob(value)!=null)?(this.isJSON(atob(value))?JSON.parse(atob(value)):atob(value)):value;

  //   }
  //   else
  //   {
  //     return (this.isJSON(value)?JSON.parse(value):value);
  //   }
  // }
  // catch(e)
  // {
  //   console.error('enc/dec logout key'+key,'value='+value)
  //   window.localStorage.clear();
  //   window.location.href=window.location.origin+"/#/login"
  // }
  let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
  let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
  try {
    if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && (localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg=='&&is_cookie!='1'))
    {
      let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
      return this.isJSON(dec)?JSON.parse(dec):dec;
    }
    if(is_cookie=='1')
    {
      //console.log('is_cookie='+is_cookie+'key='+key)
      let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
      return this.isJSON(dec)?JSON.parse(dec):dec;
    }
    }
    catch(e)
    {
      console.error('enc/dec logout key'+key,'value='+value)
        window.localStorage.clear();
        window.sessionStorage.clear()
        window.location.href=window.location.origin+"/#/login"
    }

  }
isJSON(str) {
  try {
      return (JSON.parse(str));
  } catch (e) {
      return false;
  }
}
}



// WEBPACK FOOTER //
// /codebuild/output/src1804623912/src/src/app/shared/services/storage/local-storage.service.ts